import { Box, makeStyles } from '@material-ui/core';
import { Business, ChromeReaderMode, Email, Person, Phone, Store, Web } from '@material-ui/icons';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import InputCheckbox from '../../../../../../components/Inputs/Checkbox';
import { FontSizes } from '../../../../../../core/config/mainTheme';
import {
  useConnectionsDispatch,
  useConnectionsState,
} from '../ConnectionsContext/ConnectionsContext';
import {
  ConnectionsContextActionTypes,
  ConnectionsFromInterface,
} from '../ConnectionsContext/ConnectionsContext.types';

interface Props {
  path?: string;
}

interface ConnectionFormValues {
  companies: boolean;
  branches: boolean;
  persons: boolean;
  phone: boolean;
  email: boolean;
  address: boolean;
  website: boolean;
  historicalType: boolean;
  shareholder: boolean;
  beneficialOwner: boolean;
  administrator: boolean;
  auditor: boolean;
  memberOfTheBoard: boolean;
  branchManager: boolean;
  empoweredToSign: boolean;
  founder: boolean;
  liablePartner: boolean;
  generalAgent: boolean;
  liquidator: boolean;
  management: boolean;
  other: boolean;
  memberOfSupervisoryBoard: boolean;
}

const ConnectionsForm: React.FC<Props> = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useConnectionsDispatch();
  const { form } = useConnectionsState();
  const { register, getValues } = useForm({
    mode: 'onChange',
  });

  return (
    <Box>
      <Box className={classes.formBox}>
        <form onChange={onHandleChange}>
          <Box className={classes.itemsContainer}>
            <Box className={classes.itemsBlockLeft}>
              <Box>
                <InputCheckbox
                  label={t('connections:form:companies')}
                  name="companies"
                  size="small"
                  defaultValue={form.companies.value}
                  indeterminate={form.companies.indeterminate}
                  colorCheckbox="secondary"
                  icon={<Business />}
                  refReg={register}
                />
              </Box>
              <Box>
                <InputCheckbox
                  label={t('connections:form:branches')}
                  name="branches"
                  size="small"
                  defaultValue={form.branches.value}
                  indeterminate={form.branches.indeterminate}
                  colorCheckbox="secondary"
                  icon={<Store />}
                  refReg={register}
                />
              </Box>
              <Box>
                <InputCheckbox
                  label={t('connections:form:persons')}
                  name="persons"
                  size="small"
                  defaultValue={form.persons.value}
                  indeterminate={form.persons.indeterminate}
                  colorCheckbox="secondary"
                  icon={<Person />}
                  refReg={register}
                />
              </Box>
              <Box className={classes.itemPerson}>
                <InputCheckbox
                  label={t('connections:form:shareholder')}
                  name="shareholder"
                  size="small"
                  defaultValue={form.shareholder.value}
                  indeterminate={form.shareholder.indeterminate}
                  colorCheckbox="secondary"
                  icon={<Person />}
                  refReg={register}
                />
              </Box>
              <Box className={classes.itemPerson}>
                <InputCheckbox
                  label={t('connections:form:beneficialOwner')}
                  name="beneficialOwner"
                  size="small"
                  defaultValue={form.beneficialOwner.value}
                  indeterminate={form.beneficialOwner.indeterminate}
                  colorCheckbox="secondary"
                  icon={<Person />}
                  refReg={register}
                />
              </Box>
              <Box className={classes.itemPerson}>
                <InputCheckbox
                  label={t('connections:form:administrator')}
                  name="administrator"
                  size="small"
                  defaultValue={form.administrator.value}
                  indeterminate={form.administrator.indeterminate}
                  colorCheckbox="secondary"
                  icon={<Person />}
                  refReg={register}
                />
              </Box>
              <Box className={classes.itemPerson}>
                <InputCheckbox
                  label={t('connections:form:auditor')}
                  name="auditor"
                  size="small"
                  defaultValue={form.auditor.value}
                  indeterminate={form.auditor.indeterminate}
                  colorCheckbox="secondary"
                  icon={<Person />}
                  refReg={register}
                />
              </Box>
              <Box className={classes.itemPerson}>
                <InputCheckbox
                  label={t('connections:form:memberOfTheBoard')}
                  name="memberOfTheBoard"
                  size="small"
                  defaultValue={form.memberOfTheBoard.value}
                  indeterminate={form.memberOfTheBoard.indeterminate}
                  colorCheckbox="secondary"
                  icon={<Person />}
                  refReg={register}
                />
              </Box>
              <Box className={classes.itemPerson}>
                <InputCheckbox
                  label={t('connections:form:branchManager')}
                  name="branchManager"
                  size="small"
                  defaultValue={form.branchManager.value}
                  indeterminate={form.branchManager.indeterminate}
                  colorCheckbox="secondary"
                  icon={<Person />}
                  refReg={register}
                />
              </Box>
              <Box className={classes.itemPerson}>
                <InputCheckbox
                  label={t('connections:form:empoweredToSign')}
                  name="empoweredToSign"
                  size="small"
                  defaultValue={form.empoweredToSign.value}
                  indeterminate={form.empoweredToSign.indeterminate}
                  colorCheckbox="secondary"
                  icon={<Person />}
                  refReg={register}
                />
              </Box>
              <Box className={classes.itemPerson}>
                <InputCheckbox
                  label={t('connections:form:founder')}
                  name="founder"
                  size="small"
                  defaultValue={form.founder.value}
                  indeterminate={form.founder.indeterminate}
                  colorCheckbox="secondary"
                  icon={<Person />}
                  refReg={register}
                />
              </Box>
              <Box className={classes.itemPerson}>
                <InputCheckbox
                  label={t('connections:form:liablePartner')}
                  name="liablePartner"
                  size="small"
                  defaultValue={form.liablePartner.value}
                  indeterminate={form.liablePartner.indeterminate}
                  colorCheckbox="secondary"
                  icon={<Person />}
                  refReg={register}
                />
              </Box>
              <Box className={classes.itemPerson}>
                <InputCheckbox
                  label={t('connections:form:generalAgent')}
                  name="generalAgent"
                  size="small"
                  defaultValue={form.generalAgent.value}
                  indeterminate={form.generalAgent.indeterminate}
                  colorCheckbox="secondary"
                  icon={<Person />}
                  refReg={register}
                />
              </Box>
              <Box className={classes.itemPerson}>
                <InputCheckbox
                  label={t('connections:form:liquidator')}
                  name="liquidator"
                  size="small"
                  defaultValue={form.liquidator.value}
                  indeterminate={form.liquidator.indeterminate}
                  colorCheckbox="secondary"
                  icon={<Person />}
                  refReg={register}
                />
              </Box>
              <Box className={classes.itemPerson}>
                <InputCheckbox
                  label={t('connections:form:management')}
                  name="management"
                  size="small"
                  defaultValue={form.management.value}
                  indeterminate={form.management.indeterminate}
                  colorCheckbox="secondary"
                  icon={<Person />}
                  refReg={register}
                />
              </Box>
              <Box className={classes.itemPerson}>
                <InputCheckbox
                  label={t('connections:form:other')}
                  name="other"
                  size="small"
                  defaultValue={form.other.value}
                  indeterminate={form.other.indeterminate}
                  colorCheckbox="secondary"
                  icon={<Person />}
                  refReg={register}
                />
              </Box>
              <Box className={classes.itemPerson}>
                <InputCheckbox
                  label={t('connections:form:memberOfSupervisoryBoard')}
                  name="memberOfSupervisoryBoard"
                  size="small"
                  defaultValue={form.memberOfSupervisoryBoard.value}
                  indeterminate={form.memberOfSupervisoryBoard.indeterminate}
                  colorCheckbox="secondary"
                  icon={<Person />}
                  refReg={register}
                />
              </Box>
            </Box>
            <Box className={classes.itemsBlockRight}>
              <Box>
                <InputCheckbox
                  label={t('connections:form:phone')}
                  name="phone"
                  size="small"
                  defaultValue={form.phone.value}
                  indeterminate={form.phone.indeterminate}
                  colorCheckbox="secondary"
                  icon={<Phone />}
                  refReg={register}
                />
              </Box>
              <Box>
                <InputCheckbox
                  label={t('connections:form:email')}
                  name="email"
                  size="small"
                  defaultValue={form.email.value}
                  indeterminate={form.email.indeterminate}
                  colorCheckbox="secondary"
                  icon={<Email />}
                  refReg={register}
                />
              </Box>
              <Box>
                <InputCheckbox
                  label={t('connections:form:address')}
                  name="address"
                  size="small"
                  defaultValue={form.address.value}
                  indeterminate={form.address.indeterminate}
                  colorCheckbox="secondary"
                  icon={<ChromeReaderMode />}
                  refReg={register}
                />
              </Box>
              <Box>
                <InputCheckbox
                  label={t('connections:form:website')}
                  name="website"
                  size="small"
                  defaultValue={form.website.value}
                  indeterminate={form.website.indeterminate}
                  colorCheckbox="secondary"
                  icon={<Web />}
                  refReg={register}
                />
              </Box>
            </Box>
          </Box>
          <Box className={classes.itemsContainer}>
            <Box>
              <InputCheckbox
                label={t('connections:form:showCurrentConnections')}
                name="historicalType"
                size="small"
                defaultValue={form.historicalType.value}
                indeterminate={form.historicalType.indeterminate}
                colorCheckbox="secondary"
                refReg={register}
              />
            </Box>
          </Box>
        </form>
      </Box>
    </Box>
  );

  function onHandleChange() {
    const formValues = getValues() as ConnectionFormValues;

    const isFormAllLinksState = (value: boolean) => {
      return (
        formValues.shareholder === value &&
        formValues.beneficialOwner === value &&
        formValues.administrator === value &&
        formValues.auditor === value &&
        formValues.memberOfTheBoard === value &&
        formValues.branchManager === value &&
        formValues.empoweredToSign === value &&
        formValues.founder === value &&
        formValues.liablePartner === value &&
        formValues.generalAgent === value &&
        formValues.liquidator === value &&
        formValues.management === value &&
        formValues.other === value &&
        formValues.memberOfSupervisoryBoard === value
      );
    };

    const allChecked = isFormAllLinksState(true);
    const allUnChecked = isFormAllLinksState(false);

    const isPersonChange = formValues.persons !== form.persons.value;

    let personValue = form.persons.value;

    if (isPersonChange) {
      personValue = formValues.persons;
    } else if (!personValue && allChecked) {
      personValue = true;
    } else if (personValue && allUnChecked) {
      personValue = false;
    }

    const generatedFormValues: ConnectionsFromInterface = {
      companies: {
        value: formValues.companies,
        indeterminate: formValues.companies ? form.companies.indeterminate : false,
      },
      branches: {
        value: formValues.branches,
        indeterminate: formValues.branches ? form.branches.indeterminate : false,
      },
      phone: {
        value: formValues.phone,
        indeterminate: formValues.phone ? form.phone.indeterminate : false,
      },
      email: {
        value: formValues.email,
        indeterminate: formValues.email ? form.email.indeterminate : false,
      },
      address: {
        value: formValues.address,
        indeterminate: formValues.address ? form.address.indeterminate : false,
      },
      website: {
        value: formValues.website,
        indeterminate: formValues.website ? form.website.indeterminate : false,
      },
      persons: {
        value: personValue,
        indeterminate: !isPersonChange && !allChecked && !allUnChecked,
      },
      shareholder: {
        value: isPersonChange ? formValues.persons : formValues.shareholder,
        indeterminate: formValues.shareholder ? form.shareholder.indeterminate : false,
      },
      beneficialOwner: {
        value: isPersonChange ? formValues.persons : formValues.beneficialOwner,
        indeterminate: formValues.beneficialOwner ? form.beneficialOwner.indeterminate : false,
      },
      administrator: {
        value: isPersonChange ? formValues.persons : formValues.administrator,
        indeterminate: formValues.administrator ? form.administrator.indeterminate : false,
      },
      auditor: {
        value: isPersonChange ? formValues.persons : formValues.auditor,
        indeterminate: formValues.auditor ? form.auditor.indeterminate : false,
      },
      memberOfTheBoard: {
        value: isPersonChange ? formValues.persons : formValues.memberOfTheBoard,
        indeterminate: formValues.memberOfTheBoard ? form.memberOfTheBoard.indeterminate : false,
      },
      branchManager: {
        value: isPersonChange ? formValues.persons : formValues.branchManager,
        indeterminate: formValues.branchManager ? form.branchManager.indeterminate : false,
      },
      empoweredToSign: {
        value: isPersonChange ? formValues.persons : formValues.empoweredToSign,
        indeterminate: formValues.empoweredToSign ? form.empoweredToSign.indeterminate : false,
      },
      founder: {
        value: isPersonChange ? formValues.persons : formValues.founder,
        indeterminate: formValues.founder ? form.founder.indeterminate : false,
      },
      liablePartner: {
        value: isPersonChange ? formValues.persons : formValues.liablePartner,
        indeterminate: formValues.liablePartner ? form.liablePartner.indeterminate : false,
      },
      generalAgent: {
        value: isPersonChange ? formValues.persons : formValues.generalAgent,
        indeterminate: formValues.generalAgent ? form.generalAgent.indeterminate : false,
      },
      liquidator: {
        value: isPersonChange ? formValues.persons : formValues.liquidator,
        indeterminate: formValues.liquidator ? form.liquidator.indeterminate : false,
      },
      management: {
        value: isPersonChange ? formValues.persons : formValues.management,
        indeterminate: formValues.management ? form.management.indeterminate : false,
      },
      other: {
        value: isPersonChange ? formValues.persons : formValues.other,
        indeterminate: formValues.other ? form.other.indeterminate : false,
      },
      memberOfSupervisoryBoard: {
        value: isPersonChange ? formValues.persons : formValues.memberOfSupervisoryBoard,
        indeterminate: formValues.memberOfSupervisoryBoard
          ? form.memberOfSupervisoryBoard.indeterminate
          : false,
      },
      historicalType: {
        value: formValues.historicalType,
        indeterminate: form.historicalType.indeterminate,
      },
    };

    dispatch({
      type: ConnectionsContextActionTypes.SetFormState,
      payload: generatedFormValues,
    });
  }
};

const useStyles = makeStyles((theme) => ({
  formBox: {
    '& .MuiTypography-root': {
      fontSize: FontSizes.connectionFormSize,
    },
    '& .MuiCheckbox-root': {
      padding: '4px',
      '&.Mui-checked': {
        '& .MuiIconButton-label': {
          '&:after': {
            position: 'absolute',
            backgroundColor: theme.palette.primary.dark,
            color: theme.palette.primary.contrastText,
            zIndex: -1,
          },
        },
      },
      '& .MuiIconButton-label': {
        position: 'relative',
        zIndex: 1,
        color: theme.palette.secondary.main,
      },
    },
  },
  icon: {
    color: theme.palette.secondary.dark,
  },
  itemsContainer: {
    display: 'flex',
  },
  itemsBlockLeft: {
    display: 'flex',
    flexDirection: 'column',
    width: '200px',
  },
  itemsBlockRight: {
    display: 'flex',
    flexDirection: 'column',
    width: '100px',
  },
  itemPerson: {
    marginLeft: theme.spacing(5),
  },
}));

export default ConnectionsForm;
